import { render, staticRenderFns } from "./VectorizationManagement.vue?vue&type=template&id=7d8629d6"
import script from "./VectorizationManagement.vue?vue&type=script&lang=js"
export * from "./VectorizationManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports